/**
 * FocusedLayout Constants
 * Shared configuration values for desktop and mobile layouts
 */

// Mobile detection breakpoint
export const MOBILE_BREAKPOINT = 768;

// Sidebar dimensions
export const MIN_SIDEBAR_WIDTH = 180;
export const MAX_SIDEBAR_WIDTH = 400;
export const DEFAULT_SIDEBAR_WIDTH = 240;

// Desktop chat dimensions
export const MIN_DESKTOP_CHAT_WIDTH = 300;
export const DEFAULT_DESKTOP_CHAT_WIDTH = 450;

// Mobile chat dimensions (percentage of viewport height)
export const DEFAULT_MOBILE_CHAT_HEIGHT = 33.33;
export const MIN_MOBILE_CHAT_HEIGHT = 30;
export const MAX_MOBILE_CHAT_HEIGHT = 85;

// Chat panel resize handle dimensions
export const DESKTOP_RESIZE_HANDLE_WIDTH = 8;
export const MOBILE_RESIZE_HANDLE_HEIGHT = 40;

// Animation timing (for onboarding)
export const CHAT_ANIMATION_DURATION = 1800; // ms
export const CHAT_ANIMATION_FALLBACK_DELAY = 2000; // ms
